import { createEntityQuery } from '../../createEntityQuery';
import {
  UserDefinedFieldsSharedService,
  type Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

/**
 * Fetches UDF field definitions for a given module ID.
 * Replaces legacy useGetUDFByModuleId(handleRequest, moduleId).
 */
export const useGetUDFFieldsByModule = createEntityQuery<
  Wealthlane_CustomerService_Dtos_UserDefinedFields_UserDefinedFieldsByModuleIdDto[],
  number
>({
  queryKey: ['udfFieldsByModule'],
  queryFn: (moduleId) =>
    UserDefinedFieldsSharedService.getApiCustomerApiAppUserDefinedFieldsUserDefinedFieldsByModuleId(
      moduleId!
    ),
});
